/** Encodes tip amount (+ optional message) in chat message body for kind TIP. */
export function formatTipChatBody(amountCoins, message) {
    const prefix = `[${String(amountCoins)}]`;
    if (message?.trim()) {
        return `${prefix} ${message.trim()}`;
    }
    return prefix;
}
export function parseTipChatBody(body) {
    const match = /^\[(\d+)\](?:\s([\s\S]*))?$/.exec(body);
    if (!match) {
        return { amountCoins: 0, message: body.length > 0 ? body : null };
    }
    const message = match[2]?.trim();
    return {
        amountCoins: Number.parseInt(match[1] ?? '0', 10),
        message: message && message.length > 0 ? message : null,
    };
}
//# sourceMappingURL=tip-chat.js.map